import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AnnouncementBanner from "./AnnouncementBanner";
import TeaPartyModal from "./TeaPartyModal";
import ChatWidget from "./ChatWidget";
import ScrollToTop from "./ScrollToTop";
import { Toaster } from "./ui/sonner";
import { FrameGuard } from "./FrameGuard";

export default function Layout() {
  const { pathname } = useLocation();
  const page = (
    <div className="min-h-screen flex flex-col bg-brand-cream">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-white focus:text-brand-teal focus:px-4 focus:py-2 focus:rounded-full focus:shadow-lg" data-testid="skip-to-content">Skip to main content</a>
      <ScrollToTop />
      <AnnouncementBanner />
      <Navbar />
      <main id="main-content" tabIndex={-1} className="flex-1 focus:outline-none">
        <Outlet />
      </main>
      <Footer />
      <TeaPartyModal />
      {pathname !== "/apply" && <ChatWidget />}
      <Toaster richColors position="top-center" />
    </div>
  );
  return pathname === "/apply" ? <FrameGuard>{page}</FrameGuard> : page;
}
